







































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import lax from "lax.js";

@Component
export default class SectionFloatingCards extends Vue {
    @Prop() items: any;

    @Prop({ default: "" }) parentId?: string;
    @Prop({ required: false, default: false }) fixedTitle?: boolean;
    @Prop({ required: false, default: false }) hasLinks?: boolean;
    @Prop({ default: "0" }) uniqueIndex?: string;

    @Ref() readonly scroller!: HTMLElement;

    @Ref() readonly sliderEl!: HTMLElement;

    scroller_height: number = NaN;

    scroll_pos: string = "relative";

    parentContainer: HTMLElement | null = null;
    parentContainerHeight: number = 0;

    floatingContainer: HTMLElement | null = null;

    floatingContainerOffset: number | undefined = NaN;

    floatingContainerHeight: number = 0;

    mounted() {
        this.init();
    }

    init() {
        this.scroller_height = NaN;
        this.scroll_pos = "relative";
        this.floatingContainer = null;
        this.floatingContainerHeight = 0;
        this.floatingContainerOffset = NaN;

        // @ts-ignore
        if (this.$root.$mq !== "sm") {
            this.$nextTick(() => {
                this.scroller_height = this.scroller.clientHeight;
                this.$nextTick(() => {
                    this.parentContainer = document.getElementById(`${this.parentId}`);
                    this.parentContainerHeight = this.parentContainer?.clientHeight ? this.parentContainer.clientHeight : 0;
                    this.floatingContainer = document.getElementById(`${this.parentId}floating-menu`);
                    this.floatingContainerHeight = this.floatingContainer?.clientHeight ? this.floatingContainer.clientHeight : 0;

                    if (this.floatingContainer) {
                        this.floatingContainerOffset = this.getPosition(this.floatingContainer).y;
                    }

                    this.initLax();

                    this.scroll_pos = "absolute";
                    this.handleScroll();
                });
            });
        }
    }

    private initLax() {
        lax.init();

        lax.addDriver("scrollY", function() {
            return window.scrollY;
        });

        lax.addElements(`.selector-c`, {
            scrollY: {
                translateY: [
                    [0, "pageHeight"],
                    [1, "-elHeight"]
                ]
            }
        });

        if (!this.floatingContainerOffset) {
            return;
        }

        const eFader = [0, this.scroller.clientHeight * 0.5 + (this.floatingContainerOffset - 350), this.scroller.clientHeight + (this.floatingContainerOffset - 350)];

        let customFloatDriver = `scrollY-${this.uniqueIndex}`;

        lax.addDriver(
            customFloatDriver,
            function() {
                return window.scrollY;
            },
            {}
        );

        if (!this.fixedTitle) {
            let floatClass = `.selector-${this.uniqueIndex}-f`;
            lax.addElements(floatClass, {
                [customFloatDriver]: {
                    translateY: [eFader, [0, 0, -150]],
                    opacity: [eFader, [1, 1, 0]]
                }
            });
        }

        let opacity = 0;

        if (window.innerWidth < 1661) {
            opacity = 1;
        }

        let cardClass = ".selector-card";
        lax.addElements(cardClass, {
            scrollY: {
                translateX: [
                    ["elInY-50", "elCenterY-elHeight+50", "elOutY-150-elHeight"],
                    [0, -300, 0]
                ],
                opacity: [
                    ["elInY", "elCenterY-120", "elOutY"],
                    [opacity, 1, 1]
                ]
            }
        });
    }

    created() {
        window.addEventListener("scroll", this.handleScroll);
    }

    destroyed() {
        lax.removeDriver("scrollY");

        window.removeEventListener("scroll", this.handleScroll);
    }

    private getPosition(element: HTMLElement | null) {
        var xPosition = 0;
        var yPosition = 0;

        while (element) {
            xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
            yPosition += element.offsetTop - element.scrollTop + element.clientTop;
            element = element.offsetParent as HTMLElement;
        }

        return { x: xPosition, y: yPosition };
    }

    private handleScroll() {
        if (!this.floatingContainerOffset) {
            return;
        }

        if (!this.floatingContainer) {
            return;
        }

        if (!(window.scrollY < this.scroller.clientHeight + (this.floatingContainerOffset - 350))) {
            this.floatingContainer.style.pointerEvents = "none";
        } else {
            this.floatingContainer.style.pointerEvents = "all";
        }

        let extraOffsetTop = 0;
        let extraOffsetBottom = 0;
        if (window.innerWidth < 1780) {
            extraOffsetTop = 150;
            extraOffsetBottom = 150;
            if (!!this.hasLinks) {
                extraOffsetBottom = 200;
            }
        }

        let headerHeight = 200;
        let headerWithPadding = 300;
        if (window.innerWidth < 1441) {
            headerHeight = 100;
            headerWithPadding = 200;
        }

        if (this.fixedTitle) {
            if (
                this.floatingContainerOffset - window.scrollY <= headerWithPadding - extraOffsetTop &&
                this.floatingContainerOffset - window.scrollY >= headerWithPadding + extraOffsetBottom - this.parentContainerHeight + this.floatingContainerHeight + 200
            ) {
                this.floatingContainer.style.position = "fixed";
                this.floatingContainer.style.top = `${headerWithPadding - extraOffsetTop}px`;
                this.floatingContainer.style.bottom = "unset";
                this.floatingContainer.style.opacity = "1";
                this.floatingContainer.style.zIndex = "66";
            } else if (this.fixedTitle && this.floatingContainerOffset - window.scrollY <= headerWithPadding + extraOffsetTop - this.parentContainerHeight + this.floatingContainerHeight + 200) {
                this.floatingContainer.style.position = "absolute";
                this.floatingContainer.style.top = "unset";
                this.floatingContainer.style.bottom = `${100}px`;
            } else {
                this.floatingContainer.style.position = "absolute";
                this.floatingContainer.style.top = "unset";
                this.floatingContainer.style.opacity = "1";
            }
        } else {
            if (this.floatingContainerOffset - window.scrollY <= 300) {
                this.floatingContainer.style.position = "fixed";
                this.floatingContainer.style.top = `${headerWithPadding}px`; // 200 header + 100 padding
            } else {
                this.floatingContainer.style.position = "absolute";
                this.floatingContainer.style.top = "unset";
            }
        }
    }
}
